<template>
  <div class="CollectPage">
		<img class="leftToolBackground" src="@/assets/img/appCenter/leftToolBackground.png">
    <!-- <div class="recent-use">
      <h3>最近使用</h3>
      <div>
        <div v-for="item in recentUse" :key="item.id" class="recent-use-item flex_x_item">
          <div class="recent-use-item-icon">
            <img :src="item.icon" alt="icon">
          </div>
          <div class="recent-use-item-name">{{item.name}}</div>
        </div>
      </div>
    </div> -->
    <div class="recent-use">
      <span>
				<img src="@/assets/img/appCenter/collect_active.svg">
				{{ lang.my_favorites }}
			</span>
      <div class="cp_box">
        <div v-for="item in collectData" :key="item.id" class="recent-use-item flex_x_item poin mt-5" @click="line_agent(item)">
          <img :src="item.headUrl" alt="icon" v-if="item.headUrl">
          <img :src="active_type_tab==1?agent_default_avatar[2]:muti_default_avatar[0]" alt="icon" v-else>
          <div class="recent-use-item-name">
            <el-tooltip
              placement="top"
              effect="light"
              :content="item.name"  
            >
              <span>{{item.name}}</span>
            </el-tooltip>
					</div>
        </div>
      </div>
    </div>
		
  </div>
</template>
<script>
import {myMixin} from "@/common/mixin.js"
export default {
    mixins:[myMixin],
    props:{
			active_type_tab:Number
    },
    data() {
      return {
        recentUse:[{
          name:'员工培训计划',
          id:'1',
          icon:'https://beta.cloud.cocorobo.cn/aigpt/img/ai_agent_header.88be856f.png'
        }],
        collectData:[]
      }
    },
    methods:{
      line_agent(item){
        this.bus.$emit('line_agent',item)
      },
      get_collect_data(){
        const config = {
          method: 'get',
          url: this.new_url + `/api/agents/collect_list_all?userId=${this.user.userId}`,
          headers: {
            'Content-Type': 'application/json'
          },
        };
        this.$axios(config).then(res=>{
					//console.log("👉",res)
          this.collectData=res.data;
          //console.log(this.collectData)
        }).catch(error=>{
          console.log(error)
          this.$message.error('服务器繁忙，获取收藏列表失败！');
        })
      }
    },
    activated(){
      // this.get_collect_data()
    },
		watch:{
			active_type_tab(){
				// console.log(newValue)
				// console.log(this.$message(newValue))
				this.collectData = [];
				this.get_collect_data();
			}
		},
    mounted() {
			this.collectData = [];
      this.get_collect_data()
      this.bus.$on("collect", (data) => {
        this.collectData.unshift(data)
      });
      this.bus.$on("cancel_collect", (id) => {
        const index = this.collectData.findIndex(collectData=>collectData.id==id)
        this.collectData.splice(index,1)
      });
    }
} 
</script>
<style scoped>
.CollectPage{
  height: calc(100vh - 50px);
  width: 100%;
	box-sizing: border-box;
	padding: 10px;
	position: relative;
}

.leftToolBackground{
	width: 100%;
	height: auto;
	position: absolute;
	bottom: 0;
	left: 0;
}


.recent-use{
  height: calc(100%);
	overflow:auto;
  /* box-shadow: 2px 3px 4px #eaeaea; */
  padding: 5px 10px;
}

.recent-use>span{
	font-size: 16px;
	display: flex;
	align-items: center;
	color: #00000066;
	font-weight: 400px;
}

.recent-use>span>img{
	width: 20px;
	height: 20px;
	margin-right: 5px;
}


/* .recent-use-item-icon{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.recent-use-item-icon img{
  width: 100%;
  height: 100%;
  object-fit: cover;
} */

.cp_box{
	width: 100%;
	height: auto;

	padding-top: 10px;
}

.cp_box>div{
	width: 100%;
	height: 35px;
	box-sizing: border-box;
	border-radius: 5px;
	margin-top: 8px;
	margin-bottom: 8px;
	position: relative;
	left: -10px;
	padding-left: 10px;
	transition: .3s;
	/* padding-left: 20px; */
}

.cp_box>div:hover{
	background-color: #e9f2fc;
	
}

.cp_box>div>img{
	width: 22px;
	height: 22px;
	border-radius: 50%;
	object-fit: cover;
	margin-right: 10px;
}

.cp_box>div>div{
	font-size: 16px;
	height: 100%;
	width: calc(100% - 32px);
	display: flex;
	align-items: center;
	box-sizing: border-box;
	padding: 0 5px;
	position: relative;
	left: -5px;
	
}

.cp_box>div>div>span{
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
  font-size: 14px;
  font-weight: 400;
  color: #000000E5;
}

</style>
